<template>
  <div class="p-0">
      <!-- HEAD -->

      <div class="head row p-0 g-0">
          <div class="col-12 p-0"  data-aos="fade-down" data-aos-easing="ease-out-cubic" data-aos-duration="500">
              <img :src="`${publicPath}img/RG_header.jpg`" class="img-responsive">
          </div>
      </div>

      <!-- end HEAD -->

      <div class="presentacion"  data-aos="fade" data-aos-delay="250" data-aos-easing="linear" data-aos-duration="1000">

          <div class="row g-0">
              <div class="col-12 col-lg-10 m-auto p-3 p-xl-5 text-start">
                  <h2 class="mt-5">{{ $t('presentacion.presentacion') }}</h2>
                  <hr>
                  <p class="py-2 ps-1 ps-lg-0">{{ $t('presentacion.presentacion-p1') }}</p>
                  <p class="py-2 ps-1 ps-lg-0">{{ $t('presentacion.presentacion-p2') }}</p>
                  <p class="py-2 ps-1 ps-lg-0">{{ $t('presentacion.presentacion-p3') }}</p>
                  <p class="py-2 ps-1 ps-lg-0">{{ $t('presentacion.presentacion-p4') }}</p>
                  <p class="py-2 ps-1 ps-lg-0">{{ $t('presentacion.presentacion-p5') }}</p>
                  <p class="py-2 ps-1 ps-lg-0">{{ $t('presentacion.presentacion-p6') }}</p>
                  <p class="py-2 ps-1 ps-lg-0">{{ $t('presentacion.presentacion-p7') }}</p>
                  <p class="py-2 ps-1 ps-lg-0">{{ $t('presentacion.presentacion-p8') }}</p>
                  <p class="py-2 ps-1 ps-lg-0">{{ $t('presentacion.presentacion-p9') }}</p>
                  <p class="py-2 ps-1 ps-lg-0">{{ $t('presentacion.presentacion-p10') }}</p>
                  <p>&nbsp;</p>
                  <p>&nbsp;</p>
                  <p><img :src="`${publicPath}img/RG_firma.png`"></p>
                  <p class="py-0 py-lg-3 ps-1 ps-lg-0"><strong>SANTIAGO DE GOMAR ROCA</strong><br>{{ $t('presentacion.presidente') }}</p>
              </div>
          </div>
      </div>
      <div class="contingut row g-0 py-5">

          <hr>
          <div class="row p-0 g-0">
              <div class="col-6 p-3 p-lg-0 m-0 pb-3 text-start">
                  <localized-link class="footerLink" to="/roca-group-2021/"><img :src="`${publicPath}img/breadcrumbBack.gif`" class="img-responsive" width="6"> {{ $t("nav.roca_group_2021") }}</localized-link>
              </div>

              <div class="col-6 p-3 p-lg-0 m-0 pb-3 text-end">
                  <localized-link class="footerLink" to="/roca-group-2021/2021-en-resumen">{{ $t("nav.resumen") }} <img :src="`${publicPath}img/breadcrumbGo.gif`" class="img-responsive" width="6"></localized-link>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
  export default {
    data() {
        return {
            publicPath: process.env.BASE_URL
        }
    }
  };
</script>
